export enum FolderManagementAction {
    Keep = 0,
    Attach = 1,
    Detach = 2
}